import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { getHelpUrl, HelpId } from 'owa-help';
import strings from 'owa-strings/owa-options-strings';

const HELP_WINDOW_NAME = 'o365Help';
const HELP_WINDOW_OPTIONS =
    'width=400,height=500,menubar=no,status=no,scrollbars=no,titlebar=no,toolbar=no,resizable=yes';

export interface HelpLinkProps {
    helpId: HelpId;
}

@observer
export default class HelpLink extends React.Component<HelpLinkProps, {}> {
    render() {
        return (
            <Link
                href={getHelpUrl(this.props.helpId)}
                target={HELP_WINDOW_NAME}
                onClick={this.onHelpLink}>
                {strings.options_mail_linkPreviewHelpLink}
            </Link>
        );
    }

    private onHelpLink = (ev?: React.MouseEvent<HTMLAnchorElement>) => {
        ev.preventDefault();
        window.open(getHelpUrl(this.props.helpId), HELP_WINDOW_NAME, HELP_WINDOW_OPTIONS);
    };
}
